<template>
  <div class="additional-signers-wrap">
    <div class="section-base__title-box">
      <div class="section-base__title">
        {{ title }}
      </div>
    </div>

    <FormView :statement-id="statementId" />

    <div class="form-base__footer pt-10">
      <div class="button-box justify-space-between">
        <v-btn
          v-if="statement && statement.xmlFileLink"
          depressed
          class="button-base-white"
          :href="getFileLink(statement.xmlFileLink)"
          >Скачать заявление</v-btn
        >

        <v-btn
          v-if="showButton"
          depressed
          color="primary"
          class="button-base"
          @click="sendPackage"
          >Подписать
        </v-btn>
      </div>
    </div>

    <SignatureComponent />
  </div>
</template>

<script>
import { RouteText } from '@/router';
import { mapStatementName } from '@/utils/services';
import { configSigningAdditionalSigners } from '@/app.config';
import { getFileLink } from '@/api/filestorage';
import { StatementInfoToShowModule } from '@/store/modules/statementInfoToShow';
import { StatementsJointModule } from '@/store/modules/statementsJoint';
import { ServicesModule } from '@/store/modules/services';
import { AuthModule } from '@/store/modules/auth';
import FormView from '@/components/elements/statement/FullStatementView/FormView';
import SignatureComponent from '@/components/base/SignatureComponent';

export default {
  name: 'AdditionalSigners',
  props: {
    statementId: {
      type: String,
      required: true,
    },
  },
  components: {
    FormView,
    SignatureComponent,
  },
  data() {
    return {
      RouteText,
      getFileLink,
    };
  },
  computed: {
    statement() {
      return StatementInfoToShowModule.entity;
    },
    title() {
      if (this.statement) return mapStatementName[this.statement.statementType];

      return null;
    },
    showButton() {
      const data =
        this.statement?.additionalSigners &&
        this.statement?.additionalSigners.filter((item) => {
          return item.currentUser && !item.signed;
        });
      return data && data.length > 0;
    },
  },
  methods: {
    async sendPackage() {
      try {
        const dataBase64 = await StatementsJointModule.statementXmlBase64(
          this.statementId
        );

        const runSignProps = [{ xmlSigBase64: dataBase64 }];

        if (configSigningAdditionalSigners) {
          runSignProps.push({ ...this.getDataUserCertificate() });
        }

        // подписываем XmlBase64 и получаем подпись в Base64
        const signs = await ServicesModule.runSign(...runSignProps);

        await StatementsJointModule.saveAdditionalSignature({
          statementId: this.statementId,
          xmlSigBase64: signs.xmlSigBase64[0],
        });
        this.$router.go(-1);
      } catch (error) {
        await this.$vuetify.goTo('#header-target', { duration: 200 });
      }
    },

    getDataUserCertificate() {
      const userEsia = AuthModule.user;
      const paramsEsia = AuthModule.paramsEsia;
      const roleType = AuthModule.roleType;
      const isBusinessman = AuthModule.isBusinessman;

      // organization и foreignOrganization по умолчанию имеют представителя
      // organization - inn и ogrn взяты из данных организации, snils и fio - представителя
      return {
        subjectType: roleType,
        userLastName: userEsia.lastName,
        userFirstName: userEsia.firstName,
        userMiddleName: userEsia.middleName,
        snils: paramsEsia.snils,
        inn: paramsEsia.inn,
        ogrn: paramsEsia.ogrn,
        isBusinessman: isBusinessman,
      };
    },
  },
};
</script>
